import React from 'react';
import { arrayOf, func, object } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const MenuItems = ({ menuItems = [], onClick = Function.prototype }) => {
    if (menuItems.length === 0) {
        return null;
    }

    const handleClick = (event, name) => {
        event.preventDefault(); // To prevent the default parent link behaviour

        onClick(name);
    };

    return (
        <ul className="menu-items">
            {menuItems.map(({ name, titleKey }) => (
                <li
                    key={name}
                    onClick={(event) => handleClick(event, name)}
                    className={classNames('menu-item', 'text-body-default')}
                >
                    <p>
                        <I18n k={titleKey} />
                    </p>
                </li>
            ))}
        </ul>
    );
};

MenuItems.propTypes = {
    menuItems: arrayOf(object),
    onClick: func,
};

export default MenuItems;
